const totalRowHeight = '46px'
const headerRowHeight = '56px'
const contentRowHeight = (headerRowExist = true, totalRowExist = true) =>
  ['100%', headerRowExist && headerRowHeight, totalRowExist && totalRowHeight].filter(Boolean).join(' - ')

const reportTableConfig = { totalRowHeight, headerRowHeight, contentRowHeight }

export default reportTableConfig
